import { ServiceRequestService } from './../../../../dealer-system/Services/service-request.service';
import { ServiceRequest } from './../../../../back-office/Models/ServiceRequest';
import { Component, OnInit , OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-manage-request-reply-dealer',
  templateUrl: './manage-request-reply-dealer.component.html',
  styleUrls: ['./manage-request-reply-dealer.component.scss']
})
export class ManageRequestReplyDealerComponent implements OnInit, OnDestroy {

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public solutionIsSelected = false;
  public solutionSteps = [];

  constructor(
    private requestService: ServiceRequestService,
  ) { }

  ngOnInit() {

    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        if (this.request.reply) {
          this.solutionIsSelected = true;
          this.solutionSteps = this.request.reply.solution.solutionSteps.filter((item) => !item.restricted);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
